import * as React from "react";
import { forwardRef } from "react";
const SvgEventCategoryDeployment = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M7.0116 19.5682a10.8412 10.8412 0 0 0-5.4204 10.841 10.841 10.841 0 0 0 10.841-5.4205m-10.841-7.2273a14.4546 14.4546 0 0 1 12.6477 12.6478 10.8423 10.8423 0 0 0 3.8815-3.8143 10.8426 10.8426 0 0 0 1.539-5.2198A16.2614 16.2614 0 0 0 30.5003 6.9205 5.4206 5.4206 0 0 0 25.0798 1.5a16.2615 16.2615 0 0 0-14.4545 10.841 10.84 10.84 0 0 0-9.0341 5.4204Zm18.0682-7.2273a1.8069 1.8069 0 1 0 3.6137.0001 1.8069 1.8069 0 0 0-3.6137-.0001Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2.5
}));
const ForwardRef = forwardRef(SvgEventCategoryDeployment);
export default ForwardRef;
